import StatusPicture from "./StatusPicture";

export default StatusPicture;
